/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import LogiworkWorkStateAlarm from "./components/LogiworkWorkStateAlarm";
import NewsTalkItem from "./components/NewsTalkItem";
import WrapperFavUserItem from "./components/WrapperFavUserItem";

import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import CodeList from "../../lib/CodeList";

const socket = new BuddibleSocket();
const codeList = new CodeList();

let inviteBeforeUser = {};
const _mClassName = "FavUserList";
export default function FavUserList(props) {
  const {
    loginInfo,
    isMobile,
    favUserList,
    newsChatList,
    openNewsChatRoom,
    actionSubscribe,
    favUserListDropDown,
    deleteFavUser,
    checkSelectedUserChat,
    CREATE_ROOM,
    EVENT_SOCKET_ROOM_INVITE,
    chatDataList,
    addActiveChRoom,
  } = props;

  const { t, i18n } = useTranslation();
  const [searchWord, setSearchWord] = useState("");
  const [searchByUser, setSearchByUser] = useState(false);
  const [isCreateGroupChat, setIsCreateGroupChat] = useState(false);
  const [groupChatUserList, setGroupChatUserList] = useState([]);
  const [crmType, setCrmType] = useState("");
  const [crmMainKey, setCrmMainKey] = useState("");
  const [isNewsListOpen, setIsNewsListOpen] = useState(true);
  const $search = useRef();
  const userData = {};

  const COMP_GB_TYPE = {
    A: t("logiTalk.common.comp_gb.A"),
    B: t("logiTalk.common.comp_gb.B"),
    C: t("logiTalk.common.comp_gb.C"),
    D: t("logiTalk.common.comp_gb.D"),
    E: t("logiTalk.common.comp_gb.E"),
    Z: t("logiTalk.common.comp_gb.Z"),
  };

  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_TALK_ADD_CHAT_USER,
      _mClassName,
      (b, n) => {
        if (n) {
          let addUser = [];
          for (let key in n.chUserData) {
            addUser.push({
              USER_NICK: n.chUserData[key].UserNICK,
              COMP_NM: n.chUserData[key].UserCOMPNM,
              USER_NM: n.chUserData[key].UserName,
              USER_ID: n.chUserData[key].cruUserID,
              COMP_CD: n.chUserData[key].cruUserSite,
            });
          }

          inviteBeforeUser = n.chUserData;
          setCrmType(n.crmType);
          setCrmMainKey(n.crmMainKey);
          setSearchByUser(true);
          setGroupChatUserList([...addUser]);
          setIsCreateGroupChat(true);
        }
      }
    );
  })();

  useEffect(() => {
    i18n.changeLanguage(i18n.language);

    let addChatUser = socket.getLocalDataSet(
      MsgIDList.EVENT_TALK_ADD_CHAT_USER
    );
    if (addChatUser) {
      let addUser = [];
      for (let key in addChatUser.chUserData) {
        if (key !== userData.user_id) {
          addUser.push({
            USER_NICK: addChatUser.chUserData.UserNICK,
            COMP_NM: addChatUser.chUserData[key].UserCOMPNM,
            USER_NM: addChatUser.chUserData[key].UserName,
            USER_ID: addChatUser.chUserData[key].cruUserID,
            COMP_CD: addChatUser.chUserData[key].cruUserSite,
          });
        }
      }
      setCrmType(addChatUser.crmType);
      setCrmMainKey(addChatUser.crmMainKey);
      setSearchByUser(true);
      setGroupChatUserList([...addUser]);
      setIsCreateGroupChat(true);
    }

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_TALK_ADD_CHAT_USER,
        _mClassName
      );
    };
  }, []);

  useEffect(() => {
    const groupChatUserListWrap = document.getElementById(
      "groupChatUserListWrap"
    );
    if (groupChatUserListWrap) {
      groupChatUserListWrap.scrollTop = groupChatUserListWrap.scrollHeight;
    }
  }, [groupChatUserList]);

  //나와의 채팅
  function SELF_CHAT() {
    const selfKey = `${loginInfo.comp_cd}_${loginInfo.user_id}|${loginInfo.comp_cd}_${loginInfo.user_id}`;
    const selfTalkIndex = chatDataList.findIndex(
      (item) => item.crmMainKey === selfKey
    );
    if (selfTalkIndex > -1) {
      addActiveChRoom(chatDataList[selfTalkIndex]);
    } else {
      const userList = [
        {
          cruUserSite: loginInfo.comp_cd,
          cruUserID: loginInfo.user_id,
        },
      ];
      CREATE_ROOM(userList, 1);
    }
  }

  //단체 채팅방 생성 여부 확인
  function confirmCreateGroupChat() {
    codeList.Modal.current.confirm(
      t("logiTalk.favList.msg.confirmCreateGroupChat"),
      (ret) => {
        if (ret) {
          setIsCreateGroupChat(ret);
          searchUserInputHandler(true);
        }
      }
    );
  }

  //단체채팅방 유저 선택
  function selectGroupChatUser(user) {
    let dataList = [...groupChatUserList];
    let setDataList = [];
    if (dataList.length) {
      for (let i = 0; i < dataList.length; i++) {
        if (dataList[i]["USER_KEY"] !== user["USER_KEY"]) {
          setDataList = [...dataList, user];
        } else {
          dataList.splice(i, 1);
          setDataList = [...dataList];
        }
      }
    } else {
      setDataList = [{ ...user }];
    }
    setGroupChatUserList([...setDataList]);
  }

  //단체 채팅방 생성
  function createGroupChat() {
    let userList = [];
    let chatType = 1;
    for (let i = 0; i < groupChatUserList.length; i++) {
      if (groupChatUserList[i].USER_ID !== loginInfo.user_id) {
        userList.push({
          cruUserSite: groupChatUserList[i].COMP_CD,
          cruUserID: groupChatUserList[i].USER_ID,
        });
      }
    }
    if (userList.length > 1) {
      chatType = 2;
    }
    if (Number(crmType) !== 2 || !crmMainKey) {
      CREATE_ROOM(userList, chatType, searchUserInputHandler);
    } else {
      INVITE_USER();
    }
  }

  //기존 그룹 채팅방에 사용자 초대
  function INVITE_USER() {
    let invite = [];
    for (let i = 0; i < groupChatUserList.length; i++) {
      let key = `${groupChatUserList[i].COMP_CD}_${groupChatUserList[i].USER_ID}`;
      if (!inviteBeforeUser.hasOwnProperty(key)) {
        invite.push({
          cruUserSite: groupChatUserList[i].COMP_CD,
          cruUserID: groupChatUserList[i].USER_ID,
        });
      }
    }
    EVENT_SOCKET_ROOM_INVITE(invite, crmMainKey, searchUserInputHandler);
  }

  //검색 인풋 열기닫기
  function searchUserInputHandler(val) {
    if (val === undefined) val = !searchByUser;

    inviteBeforeUser = {};
    $search.current.value = "";
    setIsCreateGroupChat(val);
    setSearchByUser(!searchByUser);
    setSearchWord("");
    setGroupChatUserList([]);
    setCrmType("");
    setCrmMainKey("");
  }

  const data = [...Object.values(favUserList)];

  return (
    <>
      <div
        className={`bg-white p-3 w-100 h-100 d-flex flex-column ${
          isMobile && isCreateGroupChat ? " position-fixed" : ""
        }`}
        style={{ zIndex: isMobile && isCreateGroupChat ? 99999 : "unset" }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h6 className="text-info font-weight-bold pb-2 mb-0">
            {t("logiTalk.favList.title")}
          </h6>
          <div className="p-2 cursor_pointer">
            <i className="fas fa-users px-2" onClick={confirmCreateGroupChat} />
            <i
              className={`${
                !searchByUser ? "fas fa-search" : "fas fa-times"
              } px-2`}
              onClick={() => searchUserInputHandler(false)}
            />
          </div>
        </div>
        {/*그룹채팅 초대 사용자 목록*/}
        {isCreateGroupChat && (
          <div className="pb-2">
            <div className="d-flex flex-row justify-content-between align-items-center py-1">
              <p className="font-weight-bold">
                {t("logiTalk.favList.createGroupChat.title")}
              </p>
              <div className="text-right">
                <button
                  className="btn btn-sm btn-outline-info font-size-08 mr-1"
                  onClick={() => {
                    searchUserInputHandler(false);
                  }}
                >
                  {t("logiTalk.favList.createGroupChat.cancel")}
                </button>
                <button
                  className="btn btn-sm btn-info font-size-08"
                  onClick={createGroupChat}
                >
                  {t("logiTalk.favList.createGroupChat.check")}
                </button>
              </div>
            </div>
            <div
              id="groupChatUserListWrap"
              className="overflow_scroll rounded border p-1"
              style={{
                maxWidth: !isMobile ? 368 : "100%",
                height: 80,
                maxHeight: 80,
              }}
            >
              {groupChatUserList.map((user, index) => {
                return (
                  <div
                    key={`${user.COMP_CD}_${user.USER_ID}_${index}`}
                    className="border d-inline-block bg-blue-light py-1 px-2 rounded-pill mr-1 mb-1 cursor_pointer font-size-08"
                    onClick={() => selectGroupChatUser(user)}
                  >
                    [{user.COMP_NM}] {user.USER_NICK}{" "}
                    <span className="font-weight-bold ml-1"> &times;</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {/*검색바*/}
        <div className={`pb-2 ${searchByUser ? "d-flex " : "d-none"}`}>
          <input
            className="form-control p-1 rounded"
            style={{ height: 32 }}
            type="text"
            placeholder={t("logiTalk.favList.createGroupChat.placeholder")}
            ref={$search}
            onChange={(e) => {
              setSearchWord(e.target.value);
            }}
          />
        </div>

        <div className={"flex-fill overflow_scroll scroll_hidden"}>
          <div
            className="d-flex flex-row justify-content-start align-items-center p-2 my-2 cursor_pointer"
            onClick={SELF_CHAT}
          >
            <div
              className="border rounded-circle overflow-hidden mr-2"
              style={{
                background: `url(${loginInfo.USER_PIC}) 50% 50% / cover no-repeat`,
                width: 46,
                height: 46,
              }}
            />
            <div className="font-weight-bold">
              <div style={{ fontSize: "1.1em" }}>{loginInfo.USER_NICK}</div>
              <div className="text-secondary" style={{ fontSize: "0.8em" }}>
                [{loginInfo.comp_nm}]{" "}
                {loginInfo.USER_TEAM_NM ? `${loginInfo.USER_TEAM_NM}` : ""}
                {loginInfo.USER_TEAM_NM && loginInfo.USER_PART_NM && " | "}
                {loginInfo.USER_PART_NM}
              </div>
            </div>
          </div>
          {/*알림톡*/}
          <div>
            <div className="p-2 mb-0 d-flex flex-row justify-content-between bg-freiscop-50 rounded text-white">
              <p>📢 {t("logiTalk.favList.newsTalk.title")}</p>
              <div className="cursor_pointer px-2">
                {isNewsListOpen ? (
                  <i
                    className="fas fa-chevron-up"
                    onClick={() => {
                      setIsNewsListOpen(false);
                    }}
                  />
                ) : (
                  <i
                    className="fas fa-chevron-down"
                    onClick={() => {
                      setIsNewsListOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
            <div className={`mt-1 chUser ${isNewsListOpen ? "" : "disabled"}`}>
              <LogiworkWorkStateAlarm />
              {newsChatList.map((item) => {
                return (
                  <NewsTalkItem
                    key={item.cnmMainKey}
                    item={item}
                    openNewsChatRoom={openNewsChatRoom}
                    actionSubscribe={actionSubscribe}
                  />
                );
              })}
            </div>
          </div>
          {/*즐겨찾기 목록*/}
          {data.map((comp, i) => {
            const compKey = comp.COMP_CD + "_" + i;
            return (
              <WrapperFavUserItem
                key={compKey}
                comp={comp}
                i={i}
                COMP_GB_TYPE={COMP_GB_TYPE}
                searchWord={searchWord}
                favUserListDropDown={favUserListDropDown}
                isCreateGroupChat={isCreateGroupChat}
                checkSelectedUserChat={checkSelectedUserChat}
                deleteFavUser={deleteFavUser}
                groupChatUserList={groupChatUserList}
                selectGroupChatUser={selectGroupChatUser}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
